<template>
  <div class="register-container">
    <header>
      <!-- [{"name":"审核通过","id":1},{"name":"拉入/解除黑名单","id":2},{"name":"删除","id":3}] -->
      <span class="title">注册客户</span>
      <div class="right">
        <el-input class="seach" size="small" v-model="searchInput" placeholder="请输入内容" suffix-icon="el-icon-search" @keyup.enter.native="search"></el-input>
        <el-button size="small" @click="dialogDelete = true" :disabled="disabled" v-if="funAuth.includes(3)">删  除</el-button>
        <el-button size="small" :class="disabled ? '':'blacklist'" @click="dialogBlacklist = true" :disabled="disabled" v-if="funAuth.includes(2)">拉入黑名单</el-button>
      </div>
    </header>
    <el-table class="el-table-01" :data='tableList' style='width: 100%' @selection-change='handleSelectionChange' @row-click="rowClick">
      <el-table-column type='selection' width='55'></el-table-column>
      <el-table-column prop='company_name' label='公司名称' min-width='260'></el-table-column>
      <el-table-column prop='deployment_type' label='部署方式' min-width='120'>
        <template slot-scope='scope'>
          {{(scope.row.deployment_type === '1') ? '本地初始化':'云服务初始化'}}
        </template>
      </el-table-column>
      <el-table-column prop='user_name' label='客户姓名' min-width='140'></el-table-column>
      <el-table-column prop='phone' label='联系电话' min-width='160'></el-table-column>
      <el-table-column label='客户状态' min-width='100'>
        <template slot-scope='scope'>
          <span v-if="scope.row.status == '0'" class="s0">待审核</span>
          <span v-if="scope.row.status == '2'" class="s2">黑名单</span>
        </template>
      </el-table-column>
      <el-table-column label='注册时间' min-width='160'>
        <template slot-scope='scope'>{{ scope.row.create_time | formatDate('yyyy-MM-dd HH:mm') }}</template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change='handleSizeChange' @current-change='handleCurrentChange' :current-page='pageNum' :page-sizes='[10, 20, 50, 100]' :page-size='pageSize' layout='total, sizes, prev, pager, next, jumper' :total='tableTotal'></el-pagination>

    <el-dialog title="提示" :visible.sync="dialogBlacklist" class="prompt-box">
      <i class="iconfont icon-prompt-box"></i>
      <div class="content">拉入黑名单</div>
      <div class="note">拉入黑名单后前台将不再为该客户提供注册途径。</div>
      <div class="prompt">你确定要拉入黑名单吗？</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogBlacklist = false">取 消</el-button>
        <el-button type="primary" @click="userBlacklist">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="dialogDelete" class="prompt-box">
      <i class="iconfont icon-prompt-box"></i>
      <div class="content">删除</div>
      <div class="note">删除后不可恢复</div>
      <div class="prompt">你确定要删除吗？</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogDelete = false">取 消</el-button>
        <el-button type="primary" @click="userDelete">确 定</el-button>
      </span>
    </el-dialog>

    <div class="mask n2" v-if="dialogCusDetail" @click="dialogCusDetail = false"></div>
    <transition name="slide">
      <el-container class="data-detail-wrip" v-if="dialogCusDetail">
        <header>
          <img src="/static/images/icon-company.png">
          {{customerDetail.company_name}}
          <i class="iconfont icon-close" @click="dialogCusDetail = false"></i>
        </header>
        <div class="tab-box">
          <div class="tab-item" :class="(tabType == 0)?'active':''" @click="dtlChange(0)"><span>客户资料</span></div>
          <div class="tab-item" :class="(tabType == 1)?'active':''" @click="dtlChange(1)"><span>操作记录</span></div>
        </div>
        <div class="head" v-if="tabType == 0">
          <span>基本信息</span>
          <el-dropdown trigger="click" @command="handleCommand" v-if="funAuth.includes(2) || funAuth.includes(3)">
            <span class="el-dropdown-link">
              <i class="el-icon-arrow-down el-icon-more"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="1" v-if="customerDetail.status == 0 && funAuth.includes(2)">拉入黑名单</el-dropdown-item>
              <el-dropdown-item command="2" v-if="funAuth.includes(3)">删  除</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button type="primary" @click="editCustomer" :disabled="customerDetail.status == 2" v-if="funAuth.includes(1)">审批通过</el-button>
        </div>
        <div class="head" v-if="tabType == 1">
          <span>操作记录</span>
        </div>
        <div class="content">
          <el-collapse v-model="activeNames" v-if="tabType == 0">
            <el-collapse-item name="1">
              <template slot="title">
                <i class="iconfont icon-zhankai"></i>
                基本信息
              </template>
              <div class="form">
                <div class="item single">
                  <span class="title">客户名称</span>
                  <div class="item-content">{{customerDetail.company_name}}</div>
                </div>
                <div class="item">
                  <span class="title">客户姓名</span>
                  <div class="item-content">{{customerDetail.user_name}}</div>
                </div>
                <div class="item">
                  <span class="title">联系电话</span>
                  <div class="item-content">{{customerDetail.phone}}</div>
                </div>
                <div class="item">
                  <span class="title">客户状态</span>
                  <div class="item-content">{{(customerDetail.status == 2 ? '黑名单':'待审核')}}</div>
                </div>
                <div class="item">
                  <span class="title">部署方式</span>
                  <div class="item-content">{{(customerDetail.deployment_type == 1) ? '本地初始化':'云服务初始化'}}</div>
                </div>
                <div class="item" v-if="customerDetail.deployment_type === '1'">
                  <span class="title">域名地址</span>
                  <div class="item-content">{{customerDetail.local_domain_address}}</div>
                </div>
                <div class="item">
                  <span class="title">注册时间</span>
                  <div class="item-content">{{customerDetail.create_time | formatDate('yyyy-MM-dd HH:mm')}}</div>
                </div>
                <div class="item single">
                  <span class="title">备注</span>
                  <div class="item-content">{{customerDetail.remark}}</div>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
          <div class="log-box" v-if="tabType == 1">
            <div class="log-item" v-for="(date, index) in logList" :key="index">
              <div class="line">
                <div class="circle"></div>
              </div>
              <div class="rihgt">
                <div class="time">{{date.datetime_time | formatDate('yyyy-MM-dd HH:mm')}}</div>
                <div class="content">{{date.content}}</div>
              </div>
            </div>
          </div>
        </div>
      </el-container>
    </transition>
    <div class="mask n1" v-if="dialogAdd" @click="dialogAdd = false"></div>
    <transition name="slide">
      <customer-add v-if="dialogAdd" :customer="customerDetail"></customer-add>
    </transition>
  </div>
</template>
<script>
import {HTTPServer} from '@/common/js/ajax.js'
import customerAdd from '@/common/components/customer-add'// 新增
import mixin from '@/common/js/mixins.js'
export default {
  data () {
    return {
      defaultMsg: '<b>注册客户</b>',
      searchInput: '',
      tableList: [],
      moduleId: 0,
      pageSize: 20,
      pageNum: 1,
      tableTotal: 0,
      dialogBlacklist: false,
      dialogDelete: false,
      disabled: true,
      dialogCusDetail: false,
      customerDetail: {},
      activeNames: ['1', '2', '3'],
      dialogAdd: false,
      tabType: 0
    }
  },
  mixins: [mixin],
  mounted () {
    this.queryRegisterUserList()
    this.queryFchBtnAuth(({moduleId: this.moduleId}))
    // 关闭添加窗口
    this.$bus.on('closeAddModal', (value) => {
      if (value) {
        this.dialogAdd = false
      }
    })
    /** 注册客户审批 */
    this.$bus.off('saveAddModal')
    this.$bus.on('saveAddModal', jsondata => {
      this.adoptAccount(jsondata)
    })
  },
  components: {
    customerAdd
  },
  methods: {
    /** 获取注册客户 */
    queryRegisterUserList () {
      var jsondata = {'pageNum': this.pageNum, 'pageSize': this.pageSize, 'keyWord': this.searchValue}
      HTTPServer.queryRegisterUserList(jsondata, 'Loading').then((res) => {
        this.tableList = res.dataList
        var pageInfo = res.pageInfo
        this.tableTotal = pageInfo.totalRows
      })
    },
    /** 列表选择 */
    handleSelectionChange (val) {
      this.multipleSelection = val
      this.disabled = (this.multipleSelection.length === 0)
    },
    /** 显示每页条数 */
    handleSizeChange (val) {
      this.pageSize = val
      this.pageNum = 1
      this.queryRegisterUserList()
    },
    /** 跳转第几页 */
    handleCurrentChange (val) {
      this.pageNum = val
      this.queryRegisterUserList()
    },
    /** 搜索列表 */
    search () {
      this.searchValue = JSON.parse(JSON.stringify(this.searchInput))
      this.pageNum = 1
      this.pageSize = 20
      this.queryRegisterUserList()
    },
    /** 时间排序 */
    sortChange (column, prop, order) {
      console.log(column, prop, order)
    },
    /** 拉入黑名单 */
    userBlacklist () {
      var jsondata = this.dialogCusDetail ? [this.customerDetail] : this.multipleSelection
      HTTPServer.centerPullBlacklist(jsondata, 'Loading').then((res) => {
        this.$message({
          showClose: true,
          message: '操作成功！',
          type: 'success'
        })
        this.dialogBlacklist = false
        this.queryRegisterUserList()
        if (this.dialogCusDetail) {
          this.customerDetail.status = '2'
        }
      })
    },
    /** 删除客户 */
    userDelete (id) {
      var arr = []
      if (this.dialogCusDetail) {
        arr.push(this.customerDetail.id)
      } else {
        for (var i = 0; i < this.multipleSelection.length; i++) {
          arr.push(this.multipleSelection[i].id)
        }
      }
      var jsondata = {'id': arr.toString()}
      HTTPServer.centerDelCompanyUser(jsondata, 'Loading').then((res) => {
        this.dialogDelete = false
        this.$message({
          showClose: true,
          message: '操作成功！',
          type: 'success'
        })
        this.pageNum = 1
        this.searchValue = ''
        this.queryRegisterUserList()
        if (this.dialogCusDetail) {
          this.dialogCusDetail = false
        }
      })
    },
    /** 进入客户详情 */
    rowClick (row, event, column) {
      this.activeNames = ['1', '2']
      this.tabType = 0
      this.customerDetail = row
      this.dialogCusDetail = true
    },
    /** 点击菜单项触发的事件回调 */
    handleCommand (command) {
      if (command === '1') {
        this.dialogBlacklist = true
      } else if (command === '2') {
        this.dialogDelete = true
      }
    },
    /** 编辑客户 */
    editCustomer () {
      this.dialogAdd = true
      this.customerDetail.addType = 0
    },
    /** 审批账户 */
    adoptAccount (jsondata) {
      jsondata.id = this.customerDetail.id
      HTTPServer.centerAdoptAccount(jsondata, 'Loading').then((res) => {
        this.$message({
          message: '保存成功',
          type: 'success'
        })
        this.dialogAdd = false
        this.dialogCusDetail = false
        this.queryRegisterUserList()
      })
    },
    /** 详情导航切换 */
    dtlChange (type) {
      this.tabType = type
      if (type === 1) {
        this.queryRecordList({moduleType: this.moduleId, moduleId: this.customerDetail.id})
      }
    }
  }
}
</script>

<style scoped lang="scss">
.register-container{
  .el-table{
    height: calc(100% - 120px);
    .s0::before{
      content: "";
      display: inline-block;
      width: 6px;
      height: 6px;
      background: #1890FF;
      float: left;
      margin: 8.5px 10px 0 0;
      border-radius: 50%;
    }
    .s2::before{
      content: "";
      display: inline-block;
      width: 6px;
      height: 6px;
      background: #FF0000;
      float: left;
      margin: 8.5px 10px 0 0;
      border-radius: 50%;
    }
  }
  .blacklist:hover{
    background: #F5222D;
    border: 1px solid #F5222D;
    color: #fff;
  }
  .delete:hover{
    border: 1px solid #0091FF;
    color: #0091FF;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/customer/register.vue